import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { Route, Switch, Redirect } from 'react-router-dom';
import i18next from 'i18next';
import { PIRedirect } from './nav';
import { getAssets } from '../selectors';

import Home from './home/Home';
import Header from './header/Header';
import Order from './order/Order';
import DeliveryInfo from './delivery/DeliveryInfo';
import BranchPicker from './branches/BranchPicker';
import Checkout from './checkout/Checkout';
import OrderConfirmation from './checkout/OrderConfirmation';
import NotFound from './general/NotFound';
import Loading from './loading/Loading';

import Alert from './general/Alert';
import DeadlineAlert from './order/DeadlineAlert';

import './App.scss';

const App = () => {
    const chainId = useSelector(state => state.business.chain.id);
    const language = useSelector(state => state.app.language);    
    const appReady = useSelector(state => state.app.ready);    
    const token = useSelector(state => state.app.token);
    const orderConfirmation = useSelector(state => state.order.orderConfirmation);

    if (!appReady) {
        return <Loading showLoading />;
    }
    
    const AppRoute = ({ component: Component, header, ...rest }) => (
        <Route {...rest} render={props => {
            return (
                <Fragment>
                    {header && token ? <Header /> : null}
                    <div className="router-content">
                        <Component {...props} />
                    </div>
                </Fragment>
            );
        }} />
    );

    const PermittedRoute = (props) => {
        if (orderConfirmation) {
            return <Redirect to={`/confirmation?orderGuid=${orderConfirmation.orderGuid}`} replace />;
        }
        if (!chainId) {
            return <PIRedirect to="/notFound" />;
        }
        if (!token) {
            return <PIRedirect to="/" />;
        }

        return <AppRoute {...props} />;
    };    

    return (
        <div className="pi-app" style={{ direction: i18next.dir(language) }}>
            <Switch >
                <AppRoute header path={`/`} exact component={Home} />
                <PermittedRoute header path={`/delivery`} exact component={DeliveryInfo} />
                <PermittedRoute header path={`/branches`} exact component={BranchPicker} />
                <PermittedRoute header path={`/order`} exact component={Order} />
                <PermittedRoute header path={`/checkout`} exact component={Checkout} />
                <AppRoute path={`/confirmation`} exact component={OrderConfirmation} />
                <AppRoute path={'/notFound'} exact component={NotFound} />
                <AppRoute component={NotFound} />
            </Switch>
            <Alert />
            <DeadlineAlert />            
        </div>
    );
};

export default App;
